import { render } from "./userRole.vue?vue&type=template&id=8c2c2a7a&scoped=true"
import script from "./userRole.vue?vue&type=script&lang=js"
export * from "./userRole.vue?vue&type=script&lang=js"

import "./userRole.vue?vue&type=style&index=0&id=8c2c2a7a&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2c2a7a"]])

export default __exports__